module.exports = __webpack_public_path__ + "media/house.b71af32f.svg";